import { render, staticRenderFns } from "./transition-height.vue?vue&type=template&id=08101574&scoped=true"
import script from "./transition-height.vue?vue&type=script&lang=ts"
export * from "./transition-height.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08101574",
  null
  
)

export default component.exports